import { Checkbox, FormControlLabel } from "@mui/material";
import styled from "styled-components";
import { StyledCheckbox } from "../../../../../components/Checkboxes/checkboxes";
import { Input } from "../../../../../components/Input/input";
import FormFieldInfo from "../form-field-info/form-field-info";

interface StorageTypeSectionProps {
  currentValue: string;
  checkboxesOptions: string[];
  popoverLabel: string;
  popoverContent: string;
  formik?: any;
  helperFieldDisplay?: boolean;
  helperFieldName?: string;
  setCurrentValue: (element: string) => void;
}

const StorageTypeSection = ({
  currentValue,
  checkboxesOptions,
  popoverLabel,
  popoverContent,
  formik,
  helperFieldDisplay,
  helperFieldName,
  setCurrentValue,
}: StorageTypeSectionProps) => {
  return (
    <AdditionalServicesSectionContainer>
      <FormFieldInfo
        popoverLabel={popoverLabel}
        popoverContent={popoverContent}
      />
      <LocationWrapper>
        {checkboxesOptions.map((item, index) => (
          <ItemWrapper key={index}>
            <FormControlLabel
              key={item}
              value={item}
              control={
                <StyledCheckbox
                  onChange={() => setCurrentValue(item)}
                  name={item}
                  checked={currentValue === item}

                // sx={{ backgroundColor: "white" }}
                />
              }
              label={item}
            />
          </ItemWrapper>
        ))}
      </LocationWrapper>
    </AdditionalServicesSectionContainer>
  );
};

export default StorageTypeSection;

const AdditionalServicesSectionContainer = styled.div`
  width: 100%;
`;
const ItemWrapper = styled.div`
  width: 160px;
`;
const CustomInformationsWrapper = styled.div`
  width: 100%;
  margin-top: 8px;
`;
const LocationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 2px;
`;
